import { Button } from '@inflearn/ds-react-next';
import { useLang } from '@inflearn/i18n-tools';
import { useTranslation } from 'next-i18next';
import { INFLEARN_URL } from '../../../../../../constants/urls';
import useInstructorProfileQuery from '../../../../../../hooks/useInstructorProfileQuery';
import useQueryParams from '../../../../../../hooks/useQueryParams';

export function MentoringEditButton() {
  const { isKo } = useLang();
  const { id } = useQueryParams();
  const { data: instructorProfile } = useInstructorProfileQuery({
    userId: String(id),
    isInstructor: true,
  });
  const { t } = useTranslation();

  if (!instructorProfile || !instructorProfile.mentor) {
    return null;
  }

  const isActiveMentor = isKo && Boolean(instructorProfile.mentor?.isActive);

  if (!isActiveMentor) {
    return null;
  }

  return (
    <Button
      variant="default"
      size="sm"
      radius="md"
      component="a"
      href={INFLEARN_URL.MENTORING_SETTING(instructorProfile.mentor.id)}
    >
      {t('멘토링 설정')}
    </Button>
  );
}
